import { Row, Col, Button, Modal, Empty, Spin } from "antd";
import { useTranslation } from "react-i18next";
import UseExamIntegration from "../hooks/useExamIntegration";

const ExamIntegration = ({ admissionPatientId, branchOfficeId }) => {
  const useExamIntegration = UseExamIntegration();
  const { t } = useTranslation();

  const openModal = () => {
    useExamIntegration.setShowModal(true);
    useExamIntegration.fetchOrder(admissionPatientId);
  };

  return (
    <Row>
      <Col lg={24} xs={24}>
        <Button
          className="cmt-button secondary mb-10"
          type="primary"
          onClick={openModal}
        >
          {t('examPage.examIntegration.button')}
        </Button>
        <Modal
          className="history-modal"
          responsive
          centered
          open={useExamIntegration.showModal}
          onCancel={() => useExamIntegration.setShowModal(false)}
          footer={false}
        >
          <Row className="p-lg-20 p-xs-10">
            <Col lg={24} xs={24}>
              <h3 className="text-center mb-20 primary" style={{ fontSize: '24px' }}>{t('examPage.examIntegration.title')}</h3>
              {admissionPatientId && branchOfficeId && (
                <Row justify="end" className="mb-30">
                  <Col>
                    <Button
                      className="cmt-button secondary"
                      type="primary"
                      size="medium"
                      loading={useExamIntegration.loading.orderRequest}
                      onClick={() => useExamIntegration.handleRequestOrder(admissionPatientId)}
                    >
                      {t('examPage.examIntegration.requestOrder')}
                    </Button>
                  </Col>
                </Row>
              )}
              <Spin spinning={useExamIntegration.loading.order} className="cmt-spin">
                {useExamIntegration.orderData ? (
                  <Col lg={24} xs={24} className="mb-10 pl-15 pr-15 pt-15 pb-10 lab-order-info">
                    <p className="mb-5"><strong>{t('examPage.examIntegration.provider')}:</strong> {useExamIntegration.orderData.provider}</p>
                    <p className="mb-5"><strong>{t('examPage.examIntegration.folderId')}:</strong> {useExamIntegration.orderData.folderId}</p>
                    <p className="mb-5"><strong>{t('examPage.examIntegration.createdAt')}:</strong> {useExamIntegration.dateTranslationShort(useExamIntegration.orderData.createdAt)}</p>
                    <p className="mb-5"><strong>{t('examPage.examIntegration.folderName')}:</strong> {useExamIntegration.orderData.folderName}</p>
                  </Col>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <p className="text-center m-0">{t('examPage.examIntegration.noOrders')}</p>
                    }
                    className="mt-50"
                  />
                )}
              </Spin>
            </Col>
          </Row>
        </Modal>
      </Col>
    </Row>
  );
};

export default ExamIntegration;

